var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-wrapper"},[(_vm.label)?_c('span',{staticClass:"txt",class:{ active: _vm.value }},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"switch-btn",class:{ active: _vm.value },on:{"click":_vm.toggle}},[_c('span',{staticClass:"circle"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }